// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__2sbTU","bounce":"loader_bounce__3MT6M","secondary":"loader_secondary__1H95w loader_loader__2sbTU"};